import { PaperClassKey } from '@material-ui/core/Paper';
import { Theme } from '@material-ui/core/styles';

const MuiPaper = (theme: Theme): Partial<Record<PaperClassKey, unknown>> => {
    const borderColor = theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        /* Styles applied to the `Paper` component. */
        outlined: {
            borderColor,
        },
        rounded: {
            borderRadius: 9,
        },
    };
};

export default MuiPaper;
